import type { ChangeEvent } from 'react';
import type { HiddenInputProps } from '@/components/control/components/hidden-input/hidden-input.types';
import '@/components/control/components/hidden-input/hidden-input.css';

export default function HiddenInput(props: HiddenInputProps) {
  return (
    <input
      type={props.type}
      id={props.id}
      name={props.name}
      value={props.value}
      checked={props.checked}
      disabled={props.disabled}
      className='control-hidden-input'
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        // @ts-ignore
        if (!!e.nativeEvent?.pageX || !!e.nativeEvent.pageY) {
          e.currentTarget.blur();
          props.onChange(e, 'mouse');
        } else {
          props.onChange(e, 'keyboard');
        }
      }}
    />
  );
}
